<div class="app mat-typography"
     [class.iframe]="isInIframe">
    <app-header></app-header>
    <router-outlet></router-outlet>
    <app-footer></app-footer>
</div>
